'use client'

import { BehanceIcon, DzenIcon, TelegramIcon, VkIcon } from '@/components/Icon'
import Link from 'next/link'
import IconButton from '@/components/IconButton'
import styles from './styles.module.css'
import Map from './_components/Map'
import Contact from '../_blocks/Main_redesign/Contact'
import Typography from '@/components/Typography'
import { socialLinks } from '@/const'
import { FORMATED_PHONE, EMAIL, PHONE } from '@/shared/constants'
import AnimatedSection from '@/components/AnimatedSection'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'

export default function ContactsContent() {
	const { openConsultationModal } = useModal()

	return (
		<>
			<AnimatedSection animation="slideUp">
				<Typography variant='h1'>Контакты</Typography>
			</AnimatedSection>
			
			<AnimatedSection animation="slideUp">
				<section className={styles.contact__container}>
					<div className={styles.contact}>
						<address className={styles.address}>
							<Link href={`tel:${PHONE}`}>{FORMATED_PHONE}</Link>
							<Link href={`mailto:${EMAIL}`}>{EMAIL}</Link>
							Россия, г. Иркутск, ул. 1-ая Красноказачья, 119, 3-й этаж
						</address>
						<div className={styles.socialContainer}>
							<ul className={`${styles.list} ${styles.list__social}`}>
								<li>
									<IconButton Icon={TelegramIcon} variant='circle' size='sm' asChild>
										<Link href={socialLinks.telegram} />
									</IconButton>
								</li>
								<li>
									<IconButton Icon={VkIcon} variant='circle' size='sm' asChild>
										<Link href={socialLinks.vk} />
									</IconButton>
								</li>
								<li>
									<IconButton Icon={BehanceIcon} variant='circle' size='sm' asChild>
										<Link href={socialLinks.behance} />
									</IconButton>
								</li>
								<li>
									<IconButton Icon={DzenIcon} variant='circle' size='sm' asChild>
										<Link href={socialLinks.dzen} />
									</IconButton>
								</li>
								<li>
									<IconButton variant='circle' size='sm' asChild>
										<Link href={socialLinks.vc}>
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g clipPath="url(#clip0_2115_2862_contacts)">
													<path d="M9.58236 5.57127C10.4603 5.57127 11.1212 5.20746 11.6086 4.57409L10.9572 4.07978C10.7964 4.29069 10.5884 4.46155 10.3498 4.57889C10.1113 4.69624 9.84852 4.75687 9.58236 4.75599C8.62956 4.75599 7.93914 3.98388 7.93914 3.03646C7.93914 2.08903 8.61829 1.27343 9.60953 1.27343C10.0502 1.27343 10.3616 1.3769 10.6332 1.54431V2.37738H11.4529V1.16271L11.2958 1.03978C10.8453 0.687178 10.1572 0.5 9.58203 0.5C8.17601 0.5 7.03238 1.63757 7.03238 3.03613C7.03238 4.43338 8.17568 5.57127 9.58236 5.57127ZM11.2829 10.5737L11.2538 9.40611V6.55692H9.54427V7.37253H10.3904V9.3056C10.3904 10.1383 9.75099 10.7279 9.10596 10.7279C8.46093 10.7279 8.12433 10.283 8.12433 9.4506V6.55659H6.52748V7.3722H7.26097V9.59197C7.26097 10.7216 7.89772 11.5 9.03341 11.5C9.68606 11.5 10.183 11.1398 10.4795 10.5845H10.4928L10.6097 11.3609H11.9233V10.5747H11.2839V10.573L11.2829 10.5737ZM6.84354 0.619625H5.41897L4.17992 4.19841H4.1607L2.92828 0.619625H1.41028V1.43556H2.26403L3.73333 5.51459H4.51387V5.5136L6.04611 1.43589H6.84288V0.619957L6.84354 0.619625ZM0.0771484 11.3715H0.921291V10.5321H0.0774797V11.3715H0.0771484ZM3.3371 7.5027H3.32783L3.27482 6.55692H1.76808V7.30036H2.56982V10.574H1.76808V11.3606H5.49185V10.5895H3.4186V8.6139C3.51236 7.8988 4.05138 7.28817 4.78685 7.28817H4.80011L4.7852 8.01909H5.60482V6.5434H4.95681C4.21471 6.54143 3.66409 6.94083 3.33677 7.50303L3.3371 7.5027Z" fill="white"/>
												</g>
												<defs>
													<clipPath id="clip0_2115_2862_contacts">
														<rect width="12" height="12" fill="white"/>
													</clipPath>
												</defs>
											</svg>
										</Link>
									</IconButton>
								</li>
							</ul>
							<button 
								className={styles.consultationButton}
								onClick={openConsultationModal}
							>
								<span className={styles.buttonText}>Получить консультацию</span>
								<svg className={styles.buttonIcon} viewBox="0 0 16 16" fill="none">
									<path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="white" />
								</svg>
							</button>
						</div>
					</div>
					<div className={styles.map}>
						<Map />
					</div>
				</section>
			</AnimatedSection>
			
			<AnimatedSection animation="slideUp">
				<section className={styles.legalInfo}>
					<p className={styles.legalInfoTitle}>Юридическая информация</p>
					<address className={styles.legalInfoContent}>
						ИНН: 3811076486<br />
						КПП: 381101001<br />
						ОГРН: 1153850053598<br />
						Юридический адрес: 664081, Иркутская область, г. Иркутск. ул. Красноказачья, д. 119, офис 303
					</address>
				</section>
			</AnimatedSection>
			
			<AnimatedSection animation="slideUp">
				<div className={styles.contact__form}>
					<Contact />
				</div>
			</AnimatedSection>
		</>
	)
}
